export default __webpack_public_path__ + "static/atlassian-navigation.dark-6bc3ddfb7893524318fabd297f6faa01889a5a4ed88411ffbe0d677ad3f21378.png";